export interface IIconProps {
  type: IconTypes,
  size?: IconSizes,
  className?: string,
}

export enum IconTypes {
  visibleSecret = 'visibleSecret',
  hiddenSecret = 'hiddenSecret',
  error = 'error',
  warning = 'warning',
  success = 'success',
  radioChecked = 'radioChecked',
  radioUnchecked = 'radioUnchecked',
  checkboxUnchecked = 'checkboxUnchecked',
  checkboxChecked = 'checkboxChecked',
  arrowLeft = 'arrowLeft',
  arrowRight = 'arrowRight',
  close = 'close',
  exit = 'exit',
  user = 'user',
  userKids = 'userKids',
  wallet = 'wallet',
  login = 'login',
  lenses = 'lenses',
  map = 'map',
  menu = 'menu',
  help = 'help',
  helpMark = 'helpMark',
  aboutProgram = 'aboutProgram',
  barCode = 'barCode',
  closeMenu = 'closeMenu',
  arrowDown = 'arrowDown',
  externalLink = 'externalLink',
  internetShops = 'internetShops',
  internetShopsWrapped = 'internetShopsWrapped',
  clockBlack = 'clockBlack',
  mapMarkerBlack = 'mapMarkerBlack',
  phoneBlack = 'phoneBlack',
  info = 'info',
  filter = 'filter',
  list = 'list',
  mapView = 'mapView',
  wrenchBlueBg = 'wrenchBlueBg',
  datePicker = 'datePicker',
  timeOutside = 'timeOutside',
  gadgets = 'gadgets',
  giftBox = 'giftBox',
  visionCheckTable = 'visionCheckTable',
  bellRoundedBlue = 'bellRoundedBlue',
  lensesRoundedBlue = 'lensesRoundedBlue',
  giftRoundedBlue = 'giftRoundedBlue',
  calendarRoundedBlue = 'calendarRoundedBlue',
  phoneRoundedBlue = 'phoneRoundedBlue',
  glassesRoundedBlue = 'glassesRoundedBlue',
  treeRoundedBlue = 'treeRoundedBlue',
  eyeWithEyelashes = 'eyeWithEyelashes',
  percentRoundedDotted = 'percentRoundedDotted',
  percentRoundedBlue = 'percentRoundedBlue',
  aRoundedBlue = 'aRoundedBlue',
  noPromo = 'noPromo',
  consumerBan = 'consumerBan',
  puschasesConsumerBan = 'puschasesConsumerBan',
  voucher = 'voucher',
  attention = 'attention',
  creditCard = 'creditCard',
  shoppingBag = 'shoppingBag',
  ordersCart = 'ordersCart',
  truck = 'truck',
  clock = 'clock',
  cancel = 'cancel',
  checked = 'checked',
  checkedBlack = 'checkedBlack',
  exclamationRoundedRed = 'exclamationRoundedRed',
  clockRoundedGreen = 'clockRoundedGreen',
  screenRoundedGreen = 'screenRoundedGreen',
  paintRoundedGreen = 'paintRoundedGreen',
  aoh1d = 'aoh1d',
  aoh1dMobile = 'aoh1dMobile',
  discount = 'discount',
  store = 'store',
  phoneRetro = 'phoneRetro',
  emailRoundedBlue = 'emailRoundedBlue',
  bin = 'bin',
  plusRoundedBlue = 'plusRoundedBlue',
  unchecked = 'unchecked',
  cartWithCross = 'cartWithCross',
  infoVoucher = 'infoVoucher',
  accumulatePoints = 'accumulatePoints',
  marker3d = 'marker3d',
  clockRoundedBlue = 'clockRoundedBlue',
  checkedRoundedBlue = 'checkedRoundedBlue',
  mobile = 'mobile',
  add = 'add',
  solutionsCart = 'solutionsCart',
  benefitOne = 'benefitOne',
  benefitTwo = 'benefitTwo',
  benefitThree = 'benefitThree',
  benefitFour = 'benefitFour',
  deleteModal = 'deleteModal',
  userBlack = 'userBlack',
  infoBlue = 'infoBlue',
  location = 'location',
  radioCheckedKids = 'radioCheckedKids',
  radioUncheckedKids = 'radioUncheckedKids',
}

export enum IconSizes {
  xs = 'xs',
  sm = 'sm',
  md = 'md',
  lg = 'lg',
  xl = 'xl',
  xxl = 'xxl',
  xsm = 'xsm',
  '3xl' = '3xl',
}
